<template>
  <div class="page_salary">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" v-if="activeName2 == '0'">
            <el-form-item label="归属月" size="small" label-width="70px">
              <el-date-picker v-model="listQuery.AttrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发薪主体" size="small">
              <el-select v-model="listQuery.PayrollCompany" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form :inline="true" :model="listQuery2" class="re_down_form" label-width="88px" v-if="activeName2 == '1'">
            <el-form-item label="姓名" size="small" label-width="70px">
              <el-input v-model="listQuery2.EmployeeName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="手机号" size="small" label-width="70px">
              <el-input v-model="listQuery2.PhoneNum" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号" size="small" label-width="70px">
              <el-input v-model="listQuery2.BankAccount" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </el-form>
          <el-form :inline="true" :model="listQuery3" class="re_down_form" label-width="88px" v-if="activeName2 == '2'">
            <el-form-item label="姓名" size="small" label-width="70px">
              <el-input v-model="listQuery3.employeeName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="证件号码" size="small" label-width="70px">
              <el-input v-model="listQuery3.cardId" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery3.projectId" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput" v-if="activeName2=='0'">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="89px">
          <div v-if="activeName2=='0'">
            <div>
              <el-form-item label="商务合同主体" size="small" label-width="98px">
                <el-select v-model="listQuery.Subject" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                  <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发放途径" size="small">
                <el-select v-model="listQuery.PayrollChannel" placeholder="" clearable style="width: 180px;" filterable>
                  <el-option value="银行"></el-option>
                  <el-option value="灵活用工"></el-option>
                  <el-option value="安心云"></el-option>
                  <el-option value="现金"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发薪编号" size="small">
                <el-input v-model="listQuery.PayrollNum" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="客户名称" size="small" label-width="98px">
                <el-input v-model="listQuery.CustomerName" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
              <el-form-item label="客服" size="small">
                <el-select v-model="listQuery.Service" placeholder="" clearable style="width: 180px;" filterable>
                  <el-option v-for="(item,index) in customerList" :key="index" :value="item.Username"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业绩归属人" size="small">
                <el-select v-model="listQuery.StrAchieveowner" placeholder="" clearable style="width: 180px;" filterable>
                  <el-option v-for="(item,index) in customerList" :key="index" :value="item.Username"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="时间类型" size="small" label-width="98px">
                <el-select v-model="listQuery.SearchTimeType" style="width: 180px;" placeholder="" clearable filterable>
                  <el-option label="申请时间" value="1"></el-option>
                  <el-option label="发放时间" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker v-model="listQuery.StartTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;" :disabled="!listQuery.SearchTimeType">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker v-model="listQuery.EndTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;" :disabled="!listQuery.SearchTimeType">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs2 flex">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>算薪</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="payTips" style="margin-left:542px">注：撤销功能到待发薪流程时需联系相应出纳，前面流程可自行撤销。</div>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane :label="'算薪（' + num1 + '）'" name="算薪" v-if="roleName!='客户在线'"></el-tab-pane>
          <el-tab-pane :label="'安排资金（' + num10 + '）'" name="安排资金" v-if="roleName!='客户在线'"></el-tab-pane>
          <el-tab-pane :label="'客服主管审批（' + num2 + '）'" name="主管审批" v-if="checkPermission(['salary_manager'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'业务审批（' + num3 + '）'" name="业务审批" v-if="checkPermission(['salary_business'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'出纳确认（' + num4 + '）'" name="出纳确认" v-if="checkPermission(['salary_cashier'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'待发薪（' + num5 + '）'" name="待发薪" v-if="checkPermission(['salary_pendingSalary'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="复核发薪" name="复核发薪" v-if="checkPermission(['salary_pendingSalary'],permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'打款中（' + num11 + '）'" name="打款中" v-if="checkPermission(['salary_part'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'部分发薪（' + num6 + '）'" name="部分发薪" v-if="checkPermission(['salary_part'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'已发薪（' + num7 + '）'" name="已发薪" v-if="checkPermission(['salary_completed'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'发薪失败（' + num8 + '）'" name="发薪失败" v-if="checkPermission(['salary_fail'], permissionLists)"></el-tab-pane>
          <el-tab-pane :label="'退回记录（' + num9 + '）'" name="退回记录" v-if="checkPermission(['salary_back'], permissionLists)"></el-tab-pane>
        </el-tabs>

        <el-tabs v-model="activeName2" v-if="activeName == '算薪'" @tab-click="changeTab2">
          <el-tab-pane label="正常发放" name="0"></el-tab-pane>
          <el-tab-pane label="暂扣人员库" name="1"></el-tab-pane>
          <el-tab-pane label="6万/5000扣除异常" name="2"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex" v-if="activeName == '算薪' && activeName2 == '0'">
          <el-button type="primary" size="small" @click="addNewCala" v-if="checkPermission(['salary_addSalary'], permissionLists)">+新增发薪</el-button>
          <el-button type="success" size="small" @click="exportList" :loading="isExpLoading">导出</el-button>
          <!-- <el-button type="warning" size="small">导出人员明细</el-button>
          <el-button type="primary" size="small">导出原始导入表明细</el-button> -->
          <el-button style="background:#5EC38C;color:#fff" size="small" @click="toOfflineSalary">线下发薪数据维护</el-button>
          <el-button type="warning" size="small" @click="projectSet" v-if="checkPermission(['salary_projectSet'], permissionLists)">指定项目配置</el-button>
        </div>
        <div class="ftabBtn flex" v-if="activeName2 == '1'">
          <el-button type="primary" size="small" @click="beforeWithSubmitPay" :loading="isBtnLoading">暂扣人员发薪</el-button>
          <!-- <el-button type="success" size="small">导出</el-button> -->
          <div class="withNumBox flex">
            <div class="withNum">暂扣人数：{{ totalCount2 }}人</div>
            <div class="withNum">暂扣金额：{{ IssuedSum }}元</div>
            <div class="withNum">暂扣项目：{{ ProjectSum }}个</div>
          </div>
        </div>
        <div class="ftabBtn flex" v-if="activeName2 == '2'">
          <el-button type="primary" size="small" :loading="isBtnLoading" @click="sign6whandle(10)">登记已按6万扣除</el-button>
          <el-button type="warning" size="small" :loading="isBtnLoading" @click="sign6whandle(20)">归档</el-button>
          <el-button type="success" size="small" @click="export6wList">导出</el-button>
        </div>
        <div class="payTips" v-if="activeName == '算薪' && activeName2 == '0'" style="margin-bottom:10px">
          注：当日发薪16:00前请确认资金来源并提交申请！</div>
        <div v-if="activeName2 == '0'">
          <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" key="table1">
            <el-table-column prop="PayrollNum" label="发薪编号" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="AttrMonth" label="归属月" width="90" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IncomeTaxMonth" label="申报月" width="90" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ApplicationDate" label="发薪日" width="90" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Subject" label="商务合同主体" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PayrollCompany" label="发薪主体" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CustomerName" label="客户名称" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PayType" label="发薪类型" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PayrollChannel" label="发放途径" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="TotalPayrolls" label="发薪人数" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="TotalResponse" label="应发金额" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="GrandTotal" label="实发金额" width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div style="color:#ec5656;background:yellow">{{ row.GrandTotal }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="AmountSocialSecurityFund" label="社保公积金" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PersonalIncomeTax" label="个税" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AdvancesEmployees" label="借支" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="NeedApplyDeposit" label="申请垫支" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ProcessState" label="流程状态" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PayScaleRUL" label="导入表附件" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CustomerOriginalTableRUL" label="客户原表附件" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ApplyforRemark" label="申请备注" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ThisMonthBatch" label="本月批次" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Operator" label="申请人" width="90" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" width="150" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                {{ row.CreateTime ? row.CreateTime.replace('T', ' ') : '' }}
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" fixed="right" width="260px" v-if="activeName == '算薪'" style="margin-bottom:10px">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="association(row)">资金来源</el-button>
                  <el-button type="text" @click="beforeApplication(row)">提交申请</el-button>
                  <el-button type="text" @click="viewDtl(row)">明细</el-button>
                  <el-button type="text" @click="reselect(row.Id, 2, '', row.PayType == '预支工资' ? '预支工资' : '')">重算</el-button>
                  <el-popconfirm title="请确定是否作废？" @confirm="del(row)" style="margin-left: 10px;">
                    <el-button type="text" slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="90px" v-if="activeName == '安排资金'" style="margin-bottom:10px">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="association(row)">资金来源</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="block">
            <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
          </div>
        </div>
        <div v-if="activeName2 == '1'">
          <el-table :data="tableData2" border class="doc_table" style="width:100%;" @selection-change="handleSelectionChange2" key="table2">
            <el-table-column type="selection" align="center" width="45" fixed="left">
            </el-table-column>
            <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
              <template slot-scope="scope">
                {{ (listQuery2.pageNum - 1) * Number(listQuery2.pageSize) + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="ApplicationDate" label="申请发放日期" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AttrMonth" label="归属月" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="EmployeeName" label="员工姓名" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DepositBank" label="开户银行" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BankAccount" label="银行帐号" width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DistributionChannel" label="发放途径" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ReleaseMode" label="发放方式" width="80" :show-overflow-tooltip="true" align="center">

            </el-table-column>
            <el-table-column prop="Remark1" label="备注" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IssuedThisMonth" label="本月实发" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IncludesTelephoneSubsidy" label="包含电话费补贴的税前应发" width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OtherTaxDeductible" label="其中其他可避税项目" width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CommunicationCharge" label="其中通讯费" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PersonalSupport" label="个人承担养老" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PersonalCare" label="个人承担医疗" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PersonalUnemployment" label="个人承担失业" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BearCostSocialSecurity" label="个人承担社保费用" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ProvidentFundCosts" label="个人承担公积金费用" width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IndividualIncomeTax" label="个人所得税" width="90" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AbourUnionFees" label="工会费" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DeductMealFee" label="扣餐费" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CompanyDeductRentUtilities" label="企业扣房租水电" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CompanyDeductsUtilities" label="公司扣房租水电" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OtherDeductions" label="其他扣款（税后）" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AdvanceWages" label="预支工资" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="TotalAfterTaxDeductions" label="税后扣款合计" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DecimalPointBalance" label="小数点差额调整（默认为正数）" width="210" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="TotalDeductible" label="扣除了所有费用的应扣合计" width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountSalaryPreviousMonth" label="当月历次发放工资金额首次工资额" width="220" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountSalaryPreviousMonth2" label="当月历次发放工资金额二次工资额" width="220" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountSalaryPreviousMonth3" label="当月历次发放工资金额三次工资额" width="220" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountSalaryPreviousMonth4" label="当月历次发放工资金额四次工资额" width="220" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ChildEducation" label="累计子女教育" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ContinuingEducation" label="累计继续教育" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="HousingLoanInterest" label="累计住房贷款利息" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AccumulatedHousingRent" label="累计住房租金" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="SupportElderlyCumulatively" label="累计赡养老人" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CumulativeInfantCareCosts" label="累计婴幼儿照护费用" width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AccumulatedPersonalPension" label="累计个人养老金" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PhoneNum" label="手机号码" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="EmploymentDay" label="用工之日" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DischargeDate" label="离职日期" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Remark1" label="备注" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PayrollCompany" label="发薪公司" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PersonalTaxIsBorne" label="税费承担方式" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="本年历月应税工资累计" width="155" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="累计应纳税所得额" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="累计应扣缴税额" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="累计已预缴税额" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="累计应补(退)税额" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DebitMoney" label="未核销借支" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="其他调整" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="备注" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="240px">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="readInfo(row)">人员信息查看</el-button>
                  <el-button type="text" @click="editInfo(row)">人员信息修改</el-button>
                  <el-popconfirm title="请确定是否删除？" style="margin-left: 10px;" @confirm="delZK(row)">
                    <el-button type="text" slot="reference">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="block">
            <el-pagination v-if="totalCount2 > 0" @current-change="currentChange2" :current-page.sync="listQuery2.pageNum" :page-size="Number(listQuery2.pageSize)" @size-change="handleSizeChange2" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount2"></el-pagination>
          </div>
        </div>

        <div v-if="activeName2 == '2'">
          <el-table :data="tableData3" border class="doc_table" style="width:100%;" @selection-change="handleSelectionChange3" key="table3">
            <el-table-column type="selection" align="center" width="45" fixed="left">
            </el-table-column>
            <el-table-column prop="applicationDate" label="申请发放日期" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="updataTime" label="算税报错时间" min-width="190" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.updataTime ? row.updataTime.replace('T',' ') : '' }}</template>
            </el-table-column>
            <el-table-column prop="payrollCompany" label="算税主体" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="projectName" label="项目名称" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="employeeName" label="员工姓名" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="idType" label="证件类型" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                {{ row.idType == 'A' ? '身份证' : row.idType == 'B' ? '护照' : row.idType == 'C' ? '港澳通行证' : row.idType == 'D' ? '台湾通行证' : row.idType == 'E' ? '军官证' : row.idType == 'F' ? '士兵证' : row.idType == 'G' ? '港澳台通行证' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="cardId" label="证件号码" min-width="170" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="issuedThisMonth" label="本月实发" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">￥{{ row.issuedThisMonth }}</template>
            </el-table-column>
            <el-table-column prop="taxErrorMsg" label="6万扣除报错信息" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </el-table>

          <div class="block">
            <el-pagination v-if="totalCount3 > 0" @current-change="currentChange3" :current-page.sync="listQuery3.pageModel.page" :page-size="Number(listQuery3.pageModel.rows)" @size-change="handleSizeChange3" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount3"></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="资金来源" :visible.sync="showAassociation" width="1100px">
      <div class="paymentBox flex">
        <div class="paymentItem">项目名称：
          <el-statistic><template slot="formatter">
              {{ info.ProjectName }}
            </template></el-statistic>
        </div>
        <div class="paymentItem">实发金额 + 个税：￥<el-statistic group-separator="," :precision="2" :value="info.GrandTotal + info.PersonalIncomeTax"></el-statistic>
        </div>
        <!-- <div class="paymentItem">实发金额 + 个税：￥
          <el-statistic group-separator="," :precision="2" :value="info.GrandTotal"></el-statistic>
        </div> -->
        <div class="paymentItem" v-if="multipleSelection.length > 0">勾选汇总金额：￥
          <el-statistic group-separator="," :precision="2" :value="selALLNum"></el-statistic>
        </div>
      </div>
      <el-table :data="PaymentData" class="doc_table" ref="multipleTable" @selection-change="handleSelectionChange" max-height="500px" style="width:100%;margin-bottom: 6px;" v-if="isOver">
        <el-table-column type="selection" width="60" fixed="left">
        </el-table-column>
        <el-table-column prop="PaymentNum" label="到款编号" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="TransactionSerialNumber" label="银行卡流水号" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="VestingMonth" label="归属月" width="140" align="center">
          <template slot-scope="{row}">
            <div v-if="!isNull(row.VestingMonth)">{{ row.VestingMonth }}</div>
            <div v-else>
              <el-date-picker v-model="VestingMonth" type="month" value-format="yyyy-MM" size="small" style="width: 120px;" @change="val=>{changeMonth(val,row)}">
              </el-date-picker>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="BankTransactionDate" label="到款时间" width="155" align="center">
          <template slot-scope={row}>
            {{ row.BankTransactionDate ? row.BankTransactionDate.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="OppositeOpeningBank" label="对方户名" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="AccountName" label="我方户名" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="IncurredAmount" label="到款金额" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="AmountClaime" label="认领金额" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="EmainingAvailableCredit" label="可用金额" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="ProjectName" label="认领项目" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="Claimant" label="认领人" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="CreateTime" label="认领时间" width="155" align="center">
          <template slot-scope={row}>
            {{ row.CreateTime ? row.CreateTime.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
      </el-table>
      <div class="block" v-if="expandTotal > 0">
        <el-pagination @current-change="currentChangeExpand" :current-page.sync="claimQuery.pageNum" :page-size="Number(claimQuery.pageSize)" @size-change="handleSizeChangeExpand" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="expandTotal"></el-pagination>
      </div>
      <el-form :inline="true">
        <el-form-item>
          <el-checkbox v-model="payForm.NeedApplyDeposit" true-label="需要申请垫支" false-label="" @change="changeDesignee">需要申请垫支</el-checkbox>
          <el-input v-model="payForm.ApplyDeposit" :disabled="!payForm.NeedApplyDeposit" placeholder="请输入垫资金额" style="width:200px;margin-left: 20px;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="发薪日期" prop="ApplicationDate">
          <el-select v-model="payForm.ApplicationDate" placeholder="" size="small" style="width: 200px;" filterable>
            <el-option v-for="(item, index) in 31" :key="index" :value="item + '日'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Subject">
          <el-input v-model="payForm.ApplicationRemarks" type="textarea" :autosize="{ minRows: 3, maxRows: 4 }" style="width:567px" size="small"></el-input>
        </el-form-item>
        <div>
          <el-form-item>
            <div class="payTips">注：安排的金额不得少于 实发金额 + 个税</div>
          </el-form-item>
        </div>
      </el-form>


      <span slot="footer" class="dialog-footer">
        <el-button @click="showAassociation = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAassociation()">确
          认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提交成功" :visible.sync="showSubTip" width="600px">
      <el-result icon="success" subTitle="提交申请成功，请关注流程审批情况。如需撤销，请到相应流程节点撤销。">
      </el-result>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSubTip = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="showSubTip = false">确
          认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="注意事项" :visible.sync="visibleReading" width="600px" :show-close="false" :close-on-click-modal="false">
      <div class="payTips2">注：当日发薪16:00前请确认资金来源并提交申请！</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="closeRead">确认,我已知晓</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提交申请" :visible.sync="showApplication" width="600px" :show-close="false">
      <div class="payTips2">该笔发薪本月批次为 {{ this.ThisMonthBatch ? this.ThisMonthBatch : ' 1 ' }},请核对“实发金额”等</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showApplication = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmApplication">提交申请</el-button>
      </span>
    </el-dialog>

    <el-dialog title="系统风控提醒" :visible.sync="showSysTips" width="1005px" :show-close="false">
      <div class="payTips2">本项目系统已存在相同提交月份+相同卡号+相同金额或相同归属月份+相同卡号+相同金的发薪数据，请确认。</div>
      <el-table :data="sysTipsData" class="doc_table" max-height="500px" style="width:100%;margin-bottom: 6px;" :loading="sysLoading">
        <el-table-column prop="updataTime" label="发生时间" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="employeeName" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="projectName" label="项目" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="bankAccount" label="卡号" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="num" label="编号" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="issuedThisMonth" label="金额" min-width="140" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>{{row.issuedThisMonth ? '￥' + row.issuedThisMonth : ''}}</template>
        </el-table-column>
        <el-table-column prop="attrMonth" label="归属月" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="processState" label="发薪状态" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination v-if="sysTotal > 0" @current-change="currentChangeSys" :current-page.sync="sysQuery.PageNumber" :page-size="Number(sysQuery.PageSize)" @size-change="handleSizeChangeSys" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="sysTotal"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSysTips = false" size="small">取 消</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="confirmApplication" :loading="isBtnLoading">确认，继续</el-button>
      </span>
    </el-dialog>

    <el-dialog title="暂扣人员发薪" :visible.sync="showWithSubmitPay" width="815px" :show-close="false">
      <el-form class="re_down_form" label-width="88px">
        <el-form-item label="个税申报月" size="small" label-width="90px">
          <el-date-picker v-model="IncomeTaxMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-table :data="multipleSelection2" class="doc_table" max-height="500px" style="width:100%;margin-bottom: 6px;" :loading="sysLoading">
        <el-table-column prop="ApplicationDate" label="申请发放日期" width="120" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="AttrMonth" label="归属月" width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="EmployeeName" label="员工姓名" width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="DepositBank" label="开户银行" width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="BankAccount" label="银行帐号" width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="DistributionChannel" label="发放途径" width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="ReleaseMode" label="发放方式" width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showWithSubmitPay = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="withSubmitPay" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="人员信息查看" :visible.sync="showRead" width="660px">
      <div class="readInfo" v-if="info != {} && showRead">
        <div class="readInfoItem1">姓名：{{ info.EmployeeName }}</div>
        <div class="readInfoItem1">身份证号码：{{ info.CardId }}</div>
        <div class="readInfoItem1">银行账号：{{ info.BankAccount }}</div>
        <div class="readInfoItem1">开户行：{{ info.DepositBank }}</div>
        <div class="readInfoItem1">手机号：{{ info.PhoneNum }}</div>
        <div class="readInfoItem1">发放方式：{{ info.ReleaseMode }}</div>
        <div class="readInfoItem1">用工之日：{{ info.EmploymentDay }}</div>
        <div class="readInfoItem1">离职日期：{{ info.DischargeDate }}</div>
        <div class="readInfoItem1">应发金额：{{ info.IncludesTelephoneSubsidy }}</div>
        <div class="readInfoItem1">发薪公司：{{ info.PayrollCompany }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRead = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="人员信息修改" :visible.sync="showEdit" width="900px">
      <div v-if="info != {} && showEdit">
        <el-form :model="info" :inline="true" ref="editInfo" :rules="rules" label-width="100px">
          <el-form-item label="姓名" prop="EmployeeName">
            <el-input v-model="info.EmployeeName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" prop="CardId">
            <el-input v-model="info.CardId" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="应发金额" prop="IncludesTelephoneSubsidy">
            <el-input v-model="info.IncludesTelephoneSubsidy" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="银行帐号" prop="BankAccount">
            <el-input v-model="info.BankAccount" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="开户行" prop="DepositBank">
            <el-input v-model="info.DepositBank" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="PhoneNum">
            <el-input v-model="info.PhoneNum" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="发放方式" prop="ReleaseMode">
            <el-select v-model="info.ReleaseMode" size="small" clearable filterable style="width:300px">
              <el-option value="银行发放"></el-option>
              <el-option value="现金发放"></el-option>
              <el-option value="暂扣"></el-option>
              <el-option value="暂扣补发"></el-option>
              <el-option value="发放未成功补发"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用工之日" prop="EmploymentDay">
            <el-date-picker type="date" placeholder="" v-model="info.EmploymentDay" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="离职日期">
            <el-date-picker type="date" placeholder="" v-model="info.DischargeDate" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="发薪公司" prop="PayrollCompany">
            <el-input v-model="info.PayrollCompany" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEdit" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="异常提示" :visible.sync="showTip" width="500px">
      <div class="payTips2">
        申报月须为实际发放月份的次月及以后，否则将影响个税正确申报，请确认申报月是否正确
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTip = false" size="small">取 消</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="application" :loading="isBtnLoading">继续提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="错误提示" :visible.sync="showErr" width="800px">
      <el-table :data="errData" style="width: 100%">
        <el-table-column prop="msg" label="错误信息" min-width="750" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showErr = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    row
  } from "mathjs";
  export default {
    data() {
      return {
        listQuery: {
          name: '',
          AttrMonth: '',
          PayrollCompany: '',
          ProjectName: '',
          ProcessState: '算薪',
          pageNum: 1,
          pageSize: 10,
        },
        showDropScreen: -1,
        tableData: [],
        roleName: localStorage.roleName,
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
        num6: 0,
        num7: 0,
        num8: 0,
        num9: 0,
        num11: 0,
        expandTotal: 0,
        selALLNum: 0,
        activeName: '算薪',
        loading: false,
        showAassociation: false,
        PaymentData: [],
        payForm: {
          Id: '',
          AssociatedClaim: '', //认领ID
          NeedApplyDeposit: '', //是否垫资
          ApplyDeposit: '', //垫资金额
          ApplicationRemarks: '', //备注
          ApplicationDate: '', //发薪日期
        },
        multipleSelection: [],
        isOver: false,
        info: {},
        showSubTip: false,
        permissionLists: [],
        proNameList: [], //项目列表
        legList: [],
        num10: 0,
        visibleReading: false,
        activeName2: '0',
        listQuery2: {
          pageNum: 1,
          pageSize: 10,
          CardId: '',
          BankAccount: '',
          EmployeeName: '',
          PhoneNum: '',
        },
        ProjectSum: 0, //项目总数
        IssuedSum: 0, //暂扣金额
        tableData2: [],
        multipleSelection2: [],
        isBtnLoading: false,
        totalCount2: 0,
        showRead: false,
        info: {},
        showEdit: false,
        isExpLoading: false,
        showApplication: false,
        showSysTips: false,
        customerList: [],
        sysQuery: {
          id: '',
          PageNumber: 1,
          PageSize: 10
        },
        sysLoading: false,
        sysTotal: 0,
        sysTipsData: [],
        ThisMonthBatch: '',
        rules: {
          EmployeeName: {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          },
          CardId: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'blur'
          },
          IncludesTelephoneSubsidy: {
            required: true,
            message: '请输入应发金额',
            trigger: 'blur'
          },
          BankAccount: {
            required: true,
            message: '请输入银行帐号',
            trigger: 'blur'
          },
          DepositBank: {
            required: true,
            message: '请输入开户行',
            trigger: 'blur'
          },
          PhoneNum: {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          ReleaseMode: {
            required: true,
            message: '请选择发放方式',
            trigger: 'change'
          },
          EmploymentDay: {
            required: true,
            message: '请选择用工之日',
            trigger: 'change'
          },
          DischargeDate: {
            required: true,
            message: '请选择离职日期',
            trigger: 'change'
          },
          PayrollCompany: {
            required: true,
            message: '请输入发薪公司',
            trigger: 'blur'
          },
        },
        claimQuery: {
          ProjectIdStr: '',
          VestingMonth: '',
          AccountName: '',
          EmainingAvailableCreditMin: 0,
          pageNum: 1,
          pageSize: 200
        },
        showWithSubmitPay: false,
        IncomeTaxMonth: '',
        showTip: false,
        listQuery3: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [],
          },
          employeeName: "",
          cardId: "",
          projectId: null,
          payrollCompany: ""
        },
        tableData3: [],
        totalCount3: 0,
        multipleSelection3: [],
        errData: [],
        showErr: false,
        VestingMonth: '',
      }
    },
    created() {
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
        this.getList();
        this.listQuery.ProcessState = this.$route.query.activeName;
        this.listQuery.ProjectName = this.$route.query.projectName;
      } else {
        if (this.roleName == '客户在线') {
          this.activeName = '已发薪';
          this.changeTab();
        } else {
          this.getList();
        }
      }
      if (localStorage.visibleReadingSalary == "true") {
        this.visibleReading = true;
      }
      this.getButtonPower();
      this.getProList();
      this.getlegalsubjectlist();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/calcSalary',
          powerEnName: 'sarary'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      searchHandle() {
        if (this.activeName2 == '0') {
          this.listQuery.pageNum = 1;
          this.getList();
        } else if (this.activeName2 == '1') {
          this.getTempSuspList();
        } else {
          this.GetSubtractAnomaliesList();
        }
      },
      getList() {
        if (this.activeName == '安排资金') {
          this.appropriatFundsList();
        } else {
          this.getZNum();
          this.getApplicationPayrollList();
          this.getNum2();
          this.getFailNum();
        }
      },
      getFailNum() {
        let data = {
          pageNum: 1,
          pageSize: 0, //临时改动
          Type: '1',
          CardId: '',
          PayrollNum: '',
          BankAccount: '',
          PhoneNum: '',
          EmployeeName: '',
          IsExport: '0'
        }
        xz.getFailedDetaiOrToPaylList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.num8 = res.data.totalcount;
          } else {
            this.num8 = 0
          }
        })
      },
      //申请发薪列表
      getApplicationPayrollList() {
        this.loading = true;
        xz.getApplicationPayrollList95(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.loading = false;
          } else {
            this.$message.error('系统出错');
            this.totalCount = 0;
            this.tableData = [];
            this.loading = false;
          }
        })
      },
      getNum2() {
        xz.getApplicationPayrollListCount95(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            console.log(res.data);
            this.num1 = 0;
            this.num2 = 0;
            this.num3 = 0;
            this.num4 = 0;
            this.num5 = 0;
            this.num6 = 0;
            this.num7 = 0;
            // this.num8 = 0;
            this.num9 = 0;
            this.num11 = 0;
            if (res.data.collect1.length > 0) {
              res.data.collect1.forEach(element => {
                if (element.approverState == '待发薪') {
                  this.num5 = element.entNum
                } else if (element.approverState == '已发薪') {
                  this.num7 = element.entNum
                }
                // else if (element.ApproverState == '发薪失败') {
                //   this.num8 = element.EntNum
                // } 
                else if (element.approverState == '退回记录') {
                  this.num9 = element.entNum
                } else if (element.approverState == '出纳确认') {
                  this.num4 = element.entNum
                } else if (element.approverState == '打款中') {
                  this.num11 = element.entNum
                }
              })
            }
            if (res.data.collect.length > 0) {
              res.data.collect.forEach(element => {
                if (element.approverState == '算薪') {
                  this.num1 = element.entNum
                } else if (element.approverState == '主管审批') {
                  this.num2 = element.entNum
                } else if (element.approverState == '业务审批') {
                  this.num3 = element.entNum
                } else if (element.approverState == '部分发薪') {
                  this.num6 = element.entNum
                }
              })
            }
            this.totalCount = res.data.totalcount;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        this.listQuery.ProcessState = this.activeName;
        if (this.activeName == '算薪' || this.activeName == '安排资金') {
          this.listQuery.pageNum = 1;
          this.getList();
        } else if (this.activeName == '主管审批' || this.activeName == '业务审批' || this.activeName == '出纳确认') {
          this.$router.push({
            path: '/salaryApproval',
            query: {
              activeName: this.activeName,
              projectName: this.listQuery.ProjectName
            }
          })
        } else if (this.activeName == '待发薪' || this.activeName == '部分发薪' || this.activeName == '已发薪' || this.activeName == '发薪失败' || this.activeName == '打款中') {
          this.$router.push({
            path: '/payment',
            query: {
              activeName: this.activeName,
              projectName: this.listQuery.ProjectName
            }
          })
        } else if (this.activeName == '退回记录') {
          this.$router.push({
            path: '/returnRecord'
          })
        } else if (this.activeName == '复核发薪') {
          this.$router.push({
            path: '/reviewPay'
          })
        }
      },
      //新增
      addNewCala() {
        localStorage.setItem("salaryId", '');
        const routerUrl = this.$router.resolve({
          path: "/addCalcSalary"
        });
        const newWindow = window.open(routerUrl.href, "_blank");
        // newWindow.document.write('<h1>新窗口内容</h1>');

        // 当新窗口关闭时，刷新旧窗口
        newWindow.onbeforeunload = function () {
          window.location.reload();
        };
      },
      edit(item) {

      },
      //确认新增/修改
      confirmSubmit() {
        this.$refs["salaryForm"].validate((valid) => {
          if (valid) {}
        })
      },
      //删除
      del(row) {
        xz.cancellApplication(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApplicationPayrollList();
            this.$message.success('作废成功！')
          } else {
            this.getApplicationPayrollList();
            this.$message.error(res.msg);
          }
        })
      },
      viewDtl(row) {
        const routerUrl = this.$router.resolve({
          path: '/salaryDtl',
          query: {
            Id: row.Id,
            activeName: this.activeName
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      //重新算薪
      reselect(Id, active, ids, PayType) {
        // xz.recalculate(row.Id).then(res => {
        //   if (res.status == 'ok') {
        //     this.$message.success('重算可能会有延迟，请等待1~5分钟');
        //   } else {
        //     this.$message.error('系统出错');
        //   }
        // })
        this.$router.push({
          path: '/addCalcSalary',
          query: {
            Id: Id,
            active: active,
            ids,
            PayType
          }
        })
      },
      beforeApplication(row) {
        this.info = row;
        // 校验 IncomeTaxMonth 是否为有效日期
        const incomeTaxMoment = moment(row.IncomeTaxMonth);
        if (!incomeTaxMoment.isValid()) {
          console.error('Invalid IncomeTaxMonth:', row.IncomeTaxMonth);
          this.isBtnLoading = false;
          this.showTip = true;
          return;
        }
        const now = moment().startOf('month');
        const targetMonth = incomeTaxMoment.startOf('month');
        // 使用更准确的时间比较逻辑
        if ((targetMonth.isBefore(now) || row.IncomeTaxType === '不算税')) {
          this.isBtnLoading = false;
          this.showTip = true;
        } else {
          this.application();
        }
      },
      //提交申请
      application() {
        this.isBtnLoading = true;
        this.loading = true;
        this.sysQuery.id = this.info.Id;
        this.sysQuery.PageNumber = 1;
        xz.AdvanceFun(this.sysQuery, 'GetRiskAlertListById').then(res => {
          try {
            if (res.status == 'ok') {
              if (res.data.retList.length > 0) {
                this.sysTipsData = res.data.retList;
                this.sysTotal = res.data.totalCount;
                this.showSysTips = true;
                this.loading = false;
                this.showTip = false;
                this.isBtnLoading = false;
              } else {
                this.isBtnLoading = false;
                this.showTip = false;
                this.getAppBatch(this.info);
              }
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
              this.loading = false;
            }
          } catch (e) {
            console.log(e)
            this.isBtnLoading = false;
            this.loading = false;
            this.$message.error('系统出错')
          }
        })
      },
      currentChangeSys(val) {
        this.sysQuery.PageNumber = Number(val);
        this.getSysData();
      },
      handleSizeChangeSys(val) {
        console.log(`每页 ${val} 条`);
        this.sysQuery.PageNumber = 1;
        this.sysQuery.PageSize = val;
        this.getSysData();
      },
      getSysData() {
        this.sysLoading = true;
        xz.AdvanceFun(this.sysQuery, 'GetRiskAlertListById').then(res => {
          try {
            if (res.status == 'ok') {
              this.sysLoading = false;
              this.sysTipsData = res.data.retList;
              this.sysTotal = res.data.totalCount;
            } else {
              this.sysLoading = false;
              this.sysTipsData = [];
              this.sysTotal = 0;
              this.$message.error(res.msg);
            }
          } catch (e) {
            this.sysLoading = false;
            this.sysTipsData = [];
            this.sysTotal = 0;
            this.$message.error('系统出错')
          }
        })
      },
      getAppBatch(row) {
        xz.checkCurrentProjectSubmiTdetails(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data.length > 0) {
              res.data.forEach(element => {
                if (element.Id == row.Id) {
                  this.ThisMonthBatch = element.ThisMonthBatch;
                  this.showApplication = true;
                  this.loading = false;
                  this.isBtnLoading = false;
                }
              });
            } else {
              this.ThisMonthBatch = '1';
              this.showApplication = true;
              this.loading = false;
              this.isBtnLoading = false;
            }
          } else {
            this.loading = false;
            this.isBtnLoading = false;
            this.ThisMonthBatch = 1;
            this.showApplication = true;
          }
        })
        this.showApplication = true;
      },
      confirmApplication() {
        this.isBtnLoading = true;
        let data = {
          Work: '1', //传1是申请 
          Id: this.info.Id
        }
        // this.loading = true;
        xz.updataApplicationPayroll(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApplicationPayrollList();
            this.isBtnLoading = false;
            this.showAassociation = false;
            this.showApplication = false;
            this.showSysTips = false;
            // this.$message.success('提交申请成功！');
            this.showSubTip = true;
          } else {
            this.isBtnLoading = false;
            this.showSysTips = false;
            this.$message.error(res.msg)
          }
        })
      },
      currentChangeExpand(val) {
        this.claimQuery.pageNum = Number(val);
        this.getClaimRecordList(this.info);
      },
      handleSizeChangeExpand(val) {
        this.claimQuery.pageNum = 1;
        this.claimQuery.pageSize = val;
        this.getClaimRecordList(this.info);
      },
      getClaimRecordList(row) {
        this.claimQuery.AccountName = row.Subject;
        this.claimQuery.VestingMonthNull = '1';
        xz.getClaimRecordList(this.claimQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.PaymentData = res.data.data;
            this.loading = false;
            this.isOver = true;
            this.showAassociation = true;
            this.expandTotal = res.data.totalcount
            //默认勾选
            if (row.AssociatedClaim && res.data.data.length > 0) {
              let ids = row.AssociatedClaim.split(',');
              this.$nextTick(() => {
                ids.forEach(row => {
                  this.$refs.multipleTable.toggleRowSelection(this.PaymentData.find(item => {
                    return row == item.Id;
                  }), true)
                })
              })
            }
          } else {
            this.expandTotal = 0
            this.loading = false;
            this.isOver = true;
            this.PaymentData = [];
            this.$message.error('获取到款信息出错')
          }
        })
      },
      //获取到款信息
      association(row) {
        this.multipleSelection = [];
        this.info = row;
        this.info.GrandTotal = Number(this.info.GrandTotal);
        this.info.PersonalIncomeTax = Number(this.info.PersonalIncomeTax);
        this.payForm = {
          Id: row.Id,
          AssociatedClaim: '', //认领ID
          NeedApplyDeposit: row.NeedApplyDeposit, //是否垫资
          ApplyDeposit: row.ApplyDeposit, //垫资金额
          ApplicationRemarks: row.ApplicationRemarks, //备注
          ApplicationDate: row.ApplicationDate, //发薪日期
        }
        this.claimQuery.ProjectIdStr = row.ProjectId
        this.claimQuery.VestingMonth = row.AttrMonth
        this.loading = true;
        this.isOver = false;
        this.getClaimRecordList(row)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        let num = 0;
        if (val && val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            if (val[i] != undefined) {
              let element = val[i];
              num += Number(element.EmainingAvailableCredit)
            }
          }
          this.selALLNum = num
        } else {
          this.selALLNum = 0
        }
      },
      //确认关联
      confirmAassociation() {
        // if (this.info.TotalResponse > (this.selALLNum + this.payForm.ApplyDeposit)) {
        //   this.$message.warning('安排的金额不得少于应发金额')
        // } else {
        if (this.multipleSelection.length > 0) {
          let arr = []
          this.multipleSelection.forEach(element => {
            if (element != undefined) {
              arr.push(element.Id)
            }
          });
          this.payForm.AssociatedClaim = arr.toString();
        }
        xz.modifyAssociatedPayment(this.payForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.showAassociation = false;
            this.$message.success('关联成功！');
          } else {
            this.getList();
            this.showAassociation = false;
            this.$message.error(res.msg);
          }
        })
        // }
      },
      changeDesignee(val) {
        if (val) {
          this.payForm.ApplyDeposit = this.info.TotalResponse
        } else {
          this.payForm.ApplyDeposit = 0
        }
      },
      getZNum() {
        xz.appropriatFundsList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.num10 = res.data.totalcount;
          } else {
            this.num10 = 0;
          }
        })
      },
      appropriatFundsList() {
        this.loading = true;
        xz.appropriatFundsList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.totalCount = res.data.totalcount;
            this.tableData = res.data.data;
            this.num10 = res.data.totalcount;
            this.loading = false;
          } else {
            this.totalCount = 0;
            this.num10 = 0;
            this.tableData = [];
            this.loading = false;
          }
        })
      },
      closeRead() {
        window.localStorage.setItem("visibleReadingSalary", false);
        this.visibleReading = false;
      },
      changeTab2() {
        if (this.activeName2 == '0') {
          this.getApplicationPayrollList();
        } else if (this.activeName2 == '1') {
          this.getTempSuspList();
        } else {
          this.GetSubtractAnomaliesList()
        }
      },
      //获取暂扣人员列表
      getTempSuspList() {
        this.loading = true;
        xz.getTempSuspList(this.listQuery2, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData2 = res.data.data;
            this.IssuedSum = res.data.IssuedSum;
            this.ProjectSum = res.data.ProjectSum;
            this.totalCount2 = res.data.totalcount;
            this.loading = false;
          } else {
            this.tableData2 = [];
            this.IssuedSum = 0;
            this.ProjectSum = 0;
            this.totalCount2 = 0;
            this.loading = false;
          }
        })
      },
      //获取6万扣除异常列表
      GetSubtractAnomaliesList() {
        this.loading = true;
        xz.ApplySalaryFun(this.listQuery3, 'GetSubtractAnomaliesList').then(res => {
          if (res.status == 'ok') {
            this.tableData3 = res.data.data;
            this.totalCount3 = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData3 = [];
            this.totalCount3 = 0;
            this.loading = false;
          }
        })
      },
      currentChange2(val) {
        this.listQuery2.pageNum = Number(val);
        this.getTempSuspList();
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery2.pageNum = 1;
        this.listQuery2.pageSize = val;
        this.getTempSuspList();
      },
      handleSelectionChange2(val) {
        this.multipleSelection2 = val;
        console.log(this.multipleSelection)
      },
      beforeWithSubmitPay() {
        if (this.isBtnLoading) {
          return false
        } else if (this.multipleSelection2.length == 0) {
          this.$message.warning('请至少选择一位暂扣人员')
        } else {
          this.showWithSubmitPay = true;
        }
      },
      withSubmitPay() {
        if (this.isBtnLoading) {
          return false
        } else if (!this.IncomeTaxMonth) {
          this.$message.warning('请选择个税申报月！')
        } else {
          this.isBtnLoading = true;
          let arr = [];
          this.multipleSelection2.forEach(element => {
            arr.push(element.Id)
          });
          let d = {
            Id: arr.toString(),
            IncomeTaxMonth: this.IncomeTaxMonth
          };
          xz.withSubmitPay(d, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.isBtnLoading = false;
              this.showWithSubmitPay = false;
              this.reselect(res.data, 3, ids, '');
            } else {
              try {
                if (res.data.Data != undefined && res.data.Data == 1) {
                  this.errData = res.data.Result;
                  this.showErr = true;
                  this.isBtnLoading = false;
                  this.showWithSubmitPay = false;
                } else {
                  this.$message.error(res.msg)
                  this.isBtnLoading = false;
                  this.showWithSubmitPay = false;
                }
              } catch {
                this.$message.error(res.msg)
                this.isBtnLoading = false;
                this.showWithSubmitPay = false;
              }
            }
          })
        }
      },
      //人员信息查看
      readInfo(row) {
        this.info = row;
        console.log(this.info)
        this.showRead = true;
      },
      //人员信息修改
      editInfo(row, index) {
        this.info = row;
        this.index = index;
        this.showEdit = true;
      },
      confirmEdit() {
        this.$refs["editInfo"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.modifyTempSuspInfo(this.info, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.getTempSuspList();
                this.$message.success('修改成功');
                this.isBtnLoading = false;
                this.showEdit = false;
              } else {
                this.$message.error(res.msg)
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      //删除暂扣人员
      delZK(row) {
        let data = {
          Id: row.Id,
          IsDeleted: 1
        }
        xz.modifyTempSuspInfo(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getTempSuspList();
            this.$message.success('删除成功');
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      toOfflineSalary() {
        this.$router.push({
          path: '/offlineSalary'
        })
      },
      //导出列表
      exportList() {
        let data = this.listQuery;
        data.IsExport = '1';
        data.pageSize = 1000000;
        this.isExpLoading = true;
        xz.getApplicationPayrollList95(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = this.activeName + '列表.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isExpLoading = false;
          } else {
            this.isExpLoading = false;
            this.$message.error(res.msg)
          }
        })
      },
      projectSet() {
        const routerUrl = this.$router.resolve({
          path: "/projectSet"
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      currentChange3(val) {
        this.listQuery3.pageModel.page = Number(val);
        this.GetSubtractAnomaliesList();
      },
      handleSizeChange3(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery3.pageModel.page = 1;
        this.listQuery3.pageModel.rows = val;
        this.GetSubtractAnomaliesList();
      },
      handleSelectionChange3(val) {
        this.multipleSelection3 = val;
      },
      sign6whandle(type) {
        if (this.multipleSelection3.length > 0) {
          let arr = []
          this.multipleSelection3.forEach(element => {
            arr.push(element.id)
          });
          let d = {
            id: arr,
            type: type,
            value: true
          }
          this.isBtnLoading = true;
          xz.ApplySalaryFun(d, 'SetSubtractAnomalies').then(res => {
            if (res.status == 'ok') {
              this.isBtnLoading = false;
              this.$message.success('操作成功');
              this.GetSubtractAnomaliesList();
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.warning('请至少选择一条数据')
        }
      },
      export6wList() {
        this.loading = true;
        let d = {
          employeeName: this.listQuery3.employeeName,
          cardId: this.listQuery3.cardId,
          projectId: this.listQuery3.projectId,
          payrollCompany: this.listQuery3.employeeName
        }
        xz.ApplySalaryExpFun(d, 'ExportSubtractAnomaliesList').then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = '6万/5000扣除异常导出列表.xlsx';
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.loading = false;
          } catch (e) {
            this.loading = false;
            this.$message.error('导出异常')
          }
        })
      },
      changeMonth(val, row) {
        console.log(val, row);
        let d = {
          Id: row.Id,
          VestingMonth: val
        }
        xz.claimSpecifiedMonth(d, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('修改成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .paymentBox {
    margin: 10px 0 20px 0;
    padding-left: 30px;
  }

  .paymentItem {
    display: flex;
    white-space: nowrap;
    font-size: 14px;
    margin-right: 30px;
  }

  .payTips {
    color: red;
    padding-left: 20px;
    font-size: 14px;
  }

  .payTips2 {
    color: red;
    font-size: 16px;
  }

  .withNumBox {
    margin-left: 30px;
    line-height: 31px;
  }

  .withNum {
    margin-right: 20px;
  }

  .readInfo {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
  }

  .readInfoItem {
    width: 170px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .readInfoItem1 {
    width: 270px;
    margin-right: 10px;
    margin-bottom: 15px;
    font-size: 14px;
  }
</style>
<style>
  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  #tab-算薪 {
    /* background: rgb(255, 199, 206); */
    background: #FFFF00;
    /* color: #fff; */
  }

  #tab-安排资金 {
    /* background: rgb(255, 199, 206); */
    background: #FFFF00;
    /* color: #fff; */
  }

  .page_salary .el-breadcrumb {
    min-width: 136px;
  }
</style>